import { TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import axios from "axios";
import FormControl from "@material-ui/core/FormControl";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { Alert, Autocomplete, Skeleton } from "@material-ui/lab";
import Notification from "../notification/Notification";
import { removeTransferFromCollection } from "../../../utils/collections";
import { useTranslation } from "react-i18next";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";
import FormHelperText from "@material-ui/core/FormHelperText";

const ProjectsSelect = ({
  checkedProjects,
  setCheckedProjects,
  isObject = true,
  defaultOption = false,
  userId = null,
  label = "Project",
  error = null,
  refField= null
}) => {
  const { t } = useTranslation("otherInterface");
  const [projects, setProjects] = useState(null);
  const [forbidden, setForbidden] = useState(false);
  const [fetchingProjects, setFetchingProjects] = useState(true);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    let url = "/api/projects";

    if (userId) {
      url = url + "?user.id=" + userId;
    }

    axios.get(url, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setProjects(removeTransferFromCollection(response.data['hydra:member']));
        setFetchingProjects(false);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, []);

  if (forbidden) {
    return "Forbidden";
  }

  if (fetchingProjects) {
    return <Skeleton
      variant="rect"
      height={46}
    />;
  }

  if (Object.keys(projects).length === 0) {
    return <Alert severity="warning">{t("project.empty")}</Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <FormControl error={error} ref={refField}>
        <Autocomplete
          options={(isObject ? projects : projects.map(project => project.name)) || []}
          value={checkedProjects || null}
          onChange={(event, checkedProjects) => setCheckedProjects(checkedProjects)}
          getOptionLabel={(option) => isObject ? option.name : option}
          renderInput={(params) => (
            <TextField {...params} label={label === "Project" ? t("project.title") : ""} />
          )}
          blurOnSelect
          disableClearable={!defaultOption}
        />
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </>
  );
};

export default ProjectsSelect;